/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { Parser as c } from "./parsers.mjs";
import { Result as r } from "./result.mjs";
const s = (n) => new c((e) => new r(n, e)), a = (n, e) => n.chain((o) => e.map((t) => o.concat([t]))), w = (n) => n.reduce((e, o) => a(e, o), s([])), l = (n) => new c((e) => {
  let o = new r([], e);
  for (; !e.eof(); )
    o = o.concat(n.run(e));
  return o;
});
export {
  l as greedy,
  w as sequence
};
